import { z } from "zod";

export const setPasswordResetSchema = z.object({
  token: z.string().uuid(),
  password: z.string().min(6),
});

export const requestPasswordResetSchema = z.object({
  email: z.string().email("Email inválido"),
});
